import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material'

const actionButtonSx = {
  boxSizing: 'border-box',
  width: '100%',
  minWidth: 0,
  maxWidth: '100%',
  minHeight: 48,
  height: 48,
  py: 0,
  px: 2,
  borderRadius: 2,
  fontSize: 14,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  boxShadow: 'none',
  flexShrink: 0
}

export default function TaskConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel = 'Cancelar',
  confirmColor = 'primary',
  paperSx = {},
  titleSx = {},
  contentSx = {},
  messageSx = {},
  actionsSx = {},
  cancelButtonSx = {},
  confirmButtonSx = {},
  titleDivider = false,
  loading = false,
  onClose,
  onConfirm,
  onExited,
  transitionTimeout = 175,
  titleId = 'task-confirm-dialog-title',
  maxWidth = 'xs'
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionProps={{
        timeout: transitionTimeout,
        onExited
      }}
      fullWidth
      maxWidth={maxWidth}
      scroll="body"
      aria-labelledby={titleId}
      PaperProps={{
        sx: {
          mx: { xs: 2, sm: 'auto' },
          width: { xs: 'calc(100% - 32px)', sm: undefined },
          ...paperSx
        }
      }}
    >
      <DialogTitle
        id={titleId}
        sx={{
          ...(titleDivider ? { borderBottom: '1px solid #e4e4e4' } : {}),
          ...titleSx
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent sx={contentSx}>
        <DialogContentText component="div" sx={messageSx}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          width: '100%',
          boxSizing: 'border-box',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
          flexWrap: 'nowrap',
          gap: 1.25,
          px: 3,
          pb: 2.5,
          pt: 0,
          ...actionsSx
        }}
      >
        <Button
          variant="outlined"
          color="inherit"
          onClick={onClose}
          disabled={loading}
          sx={{
            ...actionButtonSx,
            flex: 1,
            borderWidth: 2,
            borderStyle: 'solid',
            borderColor: '#cbd5e1',
            color: '#475569',
            backgroundColor: '#fff',
            lineHeight: 1.2,
            '&:hover': {
              borderWidth: 2,
              borderColor: '#94a3b8',
              backgroundColor: '#f8fafc',
              boxShadow: 'none'
            },
            ...cancelButtonSx
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          color={confirmColor}
          disableElevation
          onClick={onConfirm}
          disabled={loading}
          sx={{
            ...actionButtonSx,
            flex: 1,
            lineHeight: 1.2,
            '&:hover': { boxShadow: 'none' },
            ...confirmButtonSx
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
